import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { bbitProdEnvironmentKey, IBbitOrganizationLegalIdentity } from '@bbitgmbh/bbit.utils';
import { BbitWebsiteMetaDataService, BbitWebsiteService } from '@bbitgmbh/website.sdk';
import { BehaviorSubject, map, share } from 'rxjs';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, AsyncPipe],
})
export class ImprintComponent implements OnInit {
  public identity = new BehaviorSubject<IBbitOrganizationLegalIdentity | undefined>(undefined);

  mailToLink = this.identity.asObservable().pipe(
    map((identity) => {
      if (!identity) {
        return '';
      }
      return `mailto:${identity.mainEMail}`;
    }),
    share(),
  );

  phoneLink = this.identity.asObservable().pipe(
    map((identity) => {
      if (!identity) {
        return '';
      }
      return `tel:${identity.mainPhone?.replace(/\s/g, '')}`;
    }),
    share(),
  );

  constructor(
    private _meta: BbitWebsiteMetaDataService,
    private _website: BbitWebsiteService,
  ) {
    this._meta.update({ title: { key: 'imprint' } });

    this.identity.next(this._website.getAuthMeta()?.environments?.[bbitProdEnvironmentKey]?.identity);
  }

  ngOnInit(): void {}
}
